"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDefaultInputMode = exports.getDefaultInputMode = exports.setDefaultLongPressDelay = exports.getDefaultLongPressDelay = exports.setDefaultHorizontalScrollSpeed = exports.getDefaultHorizontalScrollSpeed = exports.setDefaultVerticalScrollSpeed = exports.getDefaultVerticalScrollSpeed = exports.setDefaultTriggerBehavior = exports.getDefaultTriggerBehavior = exports.setDefaultBumperBehavior = exports.getDefaultBumperBehavior = exports.setDefaultSnapToEndThreshold = exports.getDefaultSnapToEndThreshold = exports.setDefaultSnapToStartThreshold = exports.getDefaultSnapToStartThreshold = exports.setDefaultScrollOffsets = exports.getDefaultScrollOffsets = exports.setDefaultScrollAlignment = exports.getDefaultScrollAlignment = void 0;
const types_1 = require("../types");
const types_2 = require("../types");
/*
    Scroll Alignment
*/
let defaultScrollAlignment = 'alignToNext';
const getDefaultScrollAlignment = () => {
    return defaultScrollAlignment;
};
exports.getDefaultScrollAlignment = getDefaultScrollAlignment;
const setDefaultScrollAlignment = (scrollAlignment) => {
    defaultScrollAlignment = scrollAlignment;
};
exports.setDefaultScrollAlignment = setDefaultScrollAlignment;
/*
    Scroll Offsets
*/
let defaultScrollOffsets = { top: 0, bottom: 0, left: 0, right: 0 };
const getDefaultScrollOffsets = () => {
    return defaultScrollOffsets;
};
exports.getDefaultScrollOffsets = getDefaultScrollOffsets;
const setDefaultScrollOffsets = (scrollOffsets) => {
    const newDefault = (0, types_1.getCompleteOffsets)(scrollOffsets);
    if (newDefault) {
        defaultScrollOffsets = newDefault;
    }
};
exports.setDefaultScrollOffsets = setDefaultScrollOffsets;
/*
    Start Threshold
*/
let defaultSnapToStartThreshold = 0;
const getDefaultSnapToStartThreshold = () => {
    return defaultSnapToStartThreshold;
};
exports.getDefaultSnapToStartThreshold = getDefaultSnapToStartThreshold;
const setDefaultSnapToStartThreshold = (snapToStartThreshold) => {
    defaultSnapToStartThreshold = snapToStartThreshold;
};
exports.setDefaultSnapToStartThreshold = setDefaultSnapToStartThreshold;
/*
    End Threshold
*/
let defaultSnapToEndThreshold = 0;
const getDefaultSnapToEndThreshold = () => {
    return defaultSnapToEndThreshold;
};
exports.getDefaultSnapToEndThreshold = getDefaultSnapToEndThreshold;
const setDefaultSnapToEndThreshold = (snapToEndThreshold) => {
    defaultSnapToEndThreshold = snapToEndThreshold;
};
exports.setDefaultSnapToEndThreshold = setDefaultSnapToEndThreshold;
/*
    Bumper Behavior
*/
let defaultBumperBehavior = types_2.BumperBehavior.Scroll;
const getDefaultBumperBehavior = () => {
    return defaultBumperBehavior;
};
exports.getDefaultBumperBehavior = getDefaultBumperBehavior;
const setDefaultBumperBehavior = (bumperBehavior) => {
    defaultBumperBehavior = bumperBehavior;
};
exports.setDefaultBumperBehavior = setDefaultBumperBehavior;
/*
    Trigger Behavior
*/
let defaultTriggerBehavior = types_1.TriggerBehavior.Scroll;
const getDefaultTriggerBehavior = () => {
    return defaultTriggerBehavior;
};
exports.getDefaultTriggerBehavior = getDefaultTriggerBehavior;
const setDefaultTriggerBehavior = (triggerBehavior) => {
    defaultTriggerBehavior = triggerBehavior;
};
exports.setDefaultTriggerBehavior = setDefaultTriggerBehavior;
/*
    Default Vertical Scroll Speed
*/
let defaultVerticalScrollSpeed = 700;
const getDefaultVerticalScrollSpeed = () => {
    return defaultVerticalScrollSpeed;
};
exports.getDefaultVerticalScrollSpeed = getDefaultVerticalScrollSpeed;
const setDefaultVerticalScrollSpeed = (scrollSpeed) => {
    defaultVerticalScrollSpeed = Math.max(1, scrollSpeed);
};
exports.setDefaultVerticalScrollSpeed = setDefaultVerticalScrollSpeed;
/*
    Default Horizontal Scroll Speed
*/
let defaultHorizontalScrollSpeed = 400;
const getDefaultHorizontalScrollSpeed = () => {
    return defaultHorizontalScrollSpeed;
};
exports.getDefaultHorizontalScrollSpeed = getDefaultHorizontalScrollSpeed;
const setDefaultHorizontalScrollSpeed = (scrollSpeed) => {
    defaultHorizontalScrollSpeed = Math.max(1, scrollSpeed);
};
exports.setDefaultHorizontalScrollSpeed = setDefaultHorizontalScrollSpeed;
/*
    Long Press Delay (ms)
*/
let defaultLongPressDelay = 500;
const getDefaultLongPressDelay = () => {
    return defaultLongPressDelay;
};
exports.getDefaultLongPressDelay = getDefaultLongPressDelay;
const setDefaultLongPressDelay = (longPressDelay) => {
    defaultLongPressDelay = longPressDelay;
};
exports.setDefaultLongPressDelay = setDefaultLongPressDelay;
/*
    Default Input Mode
*/
let defaultInputMode = types_1.DetailedInputMode.Mouse;
const getDefaultInputMode = () => {
    return defaultInputMode;
};
exports.getDefaultInputMode = getDefaultInputMode;
const setDefaultInputMode = (inputMode) => {
    defaultInputMode = (0, types_1.mapToDetailedInputMode)(inputMode);
};
exports.setDefaultInputMode = setDefaultInputMode;
//# sourceMappingURL=data:application/json;base64,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